import { motion } from 'framer-motion'
import {
  FaHome,
  FaUsers,
  FaMapMarkerAlt,
  FaWifi,
  FaCar,
  FaUtensils,
  FaTree
} from 'react-icons/fa'
import interier1 from '../album/interier/pokoj/IMG_2971.jpg'
import VirtualTour from '../VirtualTour/VirtualTour'
import './About.css'

const About = () => {
  const features = [
    {
      icon: FaHome,
      title: '9 pokojů',
      description: 'Každý s vlastním sociálním zařízením'
    },
    {
      icon: FaUsers,
      title: 'Až 34 hostů',
      description: 'Ideální pro skupinové pobyty'
    },
    {
      icon: FaMapMarkerAlt,
      title: 'Orlické hory',
      description: 'Krásné prostředí v srdci hor'
    },
    {
      icon: FaWifi,
      title: 'WiFi zdarma',
      description: 'Internet v celém objektu'
    },
    {
      icon: FaCar,
      title: 'Parkování',
      description: 'Bezplatné parkovací místa'
    },
    {
      icon: FaUtensils,
      title: 'Restaurace',
      description: 'Jídelna s výčepem a chlazením'
    },
    {
      icon: FaTree,
      title: 'Venkovní terasa',
      description: 'Venkovní posezení pod více než 325 let starou lípou'
    }
  ]

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  }

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  }

  return (
    <section className="about-section section">
      <div className="container">
        <motion.div
          className="about-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">O nás</h2>
          <p className="section-subtitle">
            Chata Jílovanka - vaše ideální destinace v Orlických horách
          </p>
        </motion.div>

        <div className="about-content">
          <motion.div
            className="about-text"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h3>Vítejte v Chatě Jílovanka</h3>
            <p>
              Naše chata se nachází v krásném prostředí v srdci Orlických hor, 
              v obci Zdobnice nedaleko Rychnova nad Kněžnou. Nabízíme ubytování 
              pro skupiny až 34 osob v 9 pokojích, každý s vlastním sociálním zařízením.
            </p>
            <p>
              Chata je ideální pro rodinné dovolené, firemní akce, oslavy, 
              svatby a jiné skupinové pobyty. Všechny pokoje jsou moderně 
              zařízené a vybavené pro maximální pohodlí našich hostů.
            </p>
            <p>
              Součástí chaty je také restaurace s výčepem a chlazením, 
              která je vybavena pro pořádání různých akcí a oslav. 
              Vlastník bydlí v oddělené sekci domu, takže je k dispozici 
              pro případné dotazy nebo pomoc.
            </p>
          </motion.div>

          <motion.div
            className="about-image"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <img src={interier1} alt="Interiér Chata Jílovanka" />
          </motion.div>
        </div>

        <motion.div
          className="features-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {features.map((feature, index) => {
            const Icon = feature.icon
            return (
              <motion.div
                key={index}
                className="feature-card"
                variants={itemVariants}
                whileHover={{ 
                  scale: 1.05,
                  transition: { duration: 0.2 }
                }}
              >
                <div className="feature-icon">
                  <Icon />
                </div>
                <h4 className="feature-title">{feature.title}</h4>
                <p className="feature-description">{feature.description}</p>
              </motion.div>
            )
          })}
        </motion.div>

        <VirtualTour compact />
      </div>
    </section>
  )
}

export default About
